import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context';

/**
 * Redirects users to their appropriate dashboard based on role/permissions.
 * All institutional users go to the main dashboard - role-based features
 * are handled within the dashboard itself.
 */
export function DashboardRedirect() {
  const { hasPermission, isAuthenticated, isLoading } = useAuth();

  // Wait for auth to fully load before redirecting
  if (isLoading || !isAuthenticated) {
    return null;
  }

  // Security officers with ONLY security access go to security dashboard
  if (hasPermission('security:view') && !hasPermission('records:read') && !hasPermission('pfiles:read')) {
    return <Navigate to="/security-audit" replace />;
  }

  // Staff members without any records access go to staff portal
  if (!hasPermission('records:read') && !hasPermission('pfiles:read')) {
    return <Navigate to="/staff-portal" replace />;
  }

  // Default: standard dashboard for all other users
  return <Navigate to="/dashboard" replace />;
}
